// src/pages/VerifyResult.jsx
import { useSearchParams, Link } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

export default function VerifyResult() {
  const [p] = useSearchParams();
  const ok  = p.get('ok') === '1';

  return (
    <Box sx={{ mt: 10, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        {ok ? '✔ Cuenta verificada' : '✖ Verificación fallida'}
      </Typography>

      <Typography sx={{ mb: 4 }}>
        {ok
          ? 'Ya puedes iniciar sesión con tu correo y contraseña.'
          : 'El enlace es incorrecto o expiró.'}
      </Typography>

      <Button component={Link} to="/" variant="contained">
        Volver al inicio
      </Button>
    </Box>
  );
}
